<template>
  <div id="ItemList" class="starter-template">
    <b-container fluid  v-if="selected === 'express'">
        <b-row class="text-center" style="padding-top: 6px">
            <b-col>
                <div class="shad" style="width: 15em; margin:auto">
                <h3 class="txtShad">{{ $t('TRAVELS') }}</h3>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="text-center shad">
                    <h4 class="txtShad">{{ $t('TRIPS') }}</h4>
                </div>
                <b-table class="backWhite descOuter mt-2"
                    id="listTableT"
                    selectable
                    :items="itemsT"
                    :fields="fields"
                    :per-page=0
                    :current-page="curPageT"
                    striped
                    head-row-variant="info"
                    @row-selected="onRowSelectedT"

                >
                </b-table>
                <b-pagination v-if="rowsT>10"
                    v-model="curPageT"
                    :total-rows="rowsT"
                    :per-page="perPage"
                    aria-controls="listTableT"
                    align="center"
                    pills
                ></b-pagination>

            </b-col>
            <b-col>
                <div class="text-center shad">
                    <h4 class="txtShad">{{ $t('PLACES') }}</h4>
                </div>
                <b-table class="backWhite descOuter mt-2"
                        id="listTableP"
                        selectable
                        :items="itemsP"
                        :fields="fields"
                        :per-page=0
                        :current-page="curPageP"
                        striped
                        head-row-variant="info"
                        @row-selected="onRowSelectedP"
                >
                </b-table>

                <b-pagination v-if="rowsP>10"
                        v-model="curPageP"
                        :total-rows="rowsP"
                        :per-page="perPage"
                        aria-controls="listTableP"
                        align="center"
                        pills
                ></b-pagination>
            </b-col>

        </b-row>
    </b-container>

    <b-container v-if="selected === 'proposals'">
        <b-row class="text-center">
            <b-col>
                <div class="shad">
                <h3>{{ $t('OFFERS') }}</h3>
                </div>
            </b-col>
        </b-row>
        <b-row>
           <b-col>
               <div class="text-center shad">
                   <h4 class="shadTxt">{{ $t('OUTINGS') }}</h4>
               </div>
               <b-table class="backWhite descOuter mt-2"
                    id="listTableO"
                    selectable
                    :items="itemsO"
                    :fields="fieldsO"
                    :per-page=0
                    :current-page="curPageO"
                    striped
                    head-row-variant="info"
                    @row-selected="onRowSelectedO"
               >
               </b-table>

               <b-pagination v-if="rowsO>10"
                   v-model="curPageO"
                   :total-rows="rowsO"
                   :per-page="perPage"
                   aria-controls="listTableO"
                   align="center"
                   pills
               ></b-pagination>

           </b-col>
        </b-row>
    </b-container>

    <b-container fluid class = "footer text-center">
         <center>
             <b-form-radio-group id="radio-group-2" v-model="selected" name="radio-sub-component">
                 <b-form-radio value="express">{{ $t('TRAVELS') }}</b-form-radio>
                 <b-form-radio value="proposals">{{ $t('OFFERS') }}</b-form-radio>
             </b-form-radio-group>
         </center>
    </b-container>
    <br><br><br><br>

  </div>

</template>

<script>
//import { BRow, BCol, BContainer, BPagination, BTable, BDropdown, BDropdownItem, BButton } from 'bootstrap-vue';
import { BRow, BCol, BContainer, BPagination, BTable, BFormRadioGroup, BFormRadio } from 'bootstrap-vue';

export default {
  name: 'ItemList',
  components: {
    BRow, BCol, BContainer, BPagination, BTable, BFormRadioGroup, BFormRadio
    //, BDropdown, BDropdownItem, BButton
  },
  data: function() {
    return {
        itemsT: [{}],
        itemsP: [{}],
        itemsO: [{}],
        item: {},
        selected: 'express',
        selectedT: null,
        selectedP: null,
        selectedO: null,
        itemType: '',
        intLoc: this.$i18n.locale,
        published: true,
        blocked: false,
        perPage: 10,
        curPageT: 1,
        curPageP: 1,
        curPageO: 1,
        curLang: '',
        listLengthT: 1,
        listLengthP: 1,
        listLengthO: 1,
        status: 'unchecked',
        title: '',
        metaDesc: ''
    }
  },
  metaInfo() {
     return {
        title: `${this.title}`,
        meta: [
            { vmid: 'description', name: 'description', content: this.metaDesc },
        ]
     }
  },
  beforeMount() {
      this.descMeta();
      this.getListT();
      this.getListP();
  },
  methods: {
    async getListT() {
        try {
            const response = await this.$http.get('getTripsList', {
                params: {
                    published: this.published,
                    blocked: this.blocked,
                    pageNum: this.curPageT,
                    listLoc: this.intLoc,
                    sort: 'byPubDate'
                }
            });
            this.itemsT = response.data.itemList;
            if(this.itemsT.length == 0)
                this.$showMsg(this.$t('EMPTY_LIST'));
            else this.listLengthT = response.data.listLen;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getListP() {
        try {
            const response = await this.$http.get('getPlacesList', {
                params: {
                    published: this.published,
                    blocked: this.blocked,
                    pageNum: this.curPageP,
                    listLoc: this.intLoc,
                    sort: 'byPubDate'
                }
            });
            this.itemsP = response.data.itemList;
            if(this.itemsP.length == 0)
                this.$showMsg(this.$t('EMPTY_LIST'));
            else this.listLengthP = response.data.listLen;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getListO() {
        try {
            const response = await this.$http.get('getOutingsList', {
                params: {
                    published: this.published,
                    blocked: this.blocked,
                    pageNum: this.curPageO,
                    listLoc: this.intLoc,
                    sort: 'byPubDate'
                }
            });
            this.itemsO = response.data.itemList;
            if(this.itemsO.length == 0)
                this.$showMsg(this.$t('EMPTY_LIST'));
            else this.listLengthO = response.data.listLen;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    onRowSelectedT(itemsT) {
        this.item = itemsT[0];
        this.$router.push({ path: 'Tour/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName) })
    },
    onRowSelectedP(itemsP) {
        this.item = itemsP[0];
        //alert(this.$addEncHyp(this.item.itemName));
        this.$router.push({ path: 'Place/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName) })
        //window.open('/Place/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName));
    },
    onRowSelectedO(itemsO) {
        this.item = itemsO[0];
        //alert('1 Outing/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName));
        this.$router.push({ path: 'Outing/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName) })
        //this.$router.push({ path: 'Offer/'+this.$addEncHyp(this.item.companyName)+'/'+this.$addEncHyp(this.item.itemName) })
    },
    chListLoc(newListLoc) {
        this.listLoc = newListLoc;
        this.curPageT = 1;
        this.curPageP = 1;
        this.curPageO = 1;
        this.getListT();
        this.getListP();
        this.getListO();
    },
    descMeta() {
        if(this.$i18n.locale === 'ru') {
            this.title = 'Новые материалы';
            this.metaDesc = 'Новые путешествия, места, экскурсии, туры';
        }
        else {
            this.title = 'New materials'
            this.metaDesc = 'New travels, places, excursions, tours';
        }
    }
  },
  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.getListT();
        this.getListP();
        this.getListO();
    },
    curPageT: function() {
        this.getListT();
    },
    curPageP: function() {
        this.getListP();
    },
    curPageO: function() {
        this.getListO();
    },
    selected: function() {
        if(this.selected === 'express') {
            this.getListT();
            this.getListP();
        }
        else this.getListO();
    }
  },
  computed: {
    rowsT() {
        return this.listLengthT;
    },
    rowsP() {
        return this.listLengthP;
    },
    rowsO() {
        return this.listLengthO;
    },
    fields() {
      return [
        { key: 'itemName', label:  this.$t('TITLE') },
        { key: 'userName', label: this.$t('AUTHOR') },
//        { key: 'pubDate', label: this.$t('DATE_PUB') }
      ]
    },
    fieldsO() {
      return [
        { key: 'itemName', label:  this.$t('TITLE') },
        { key: 'companyName', label: this.$t('ORG') },
//        { key: 'pubDate', label: this.$t('DATE_PUB') }
      ]
    }
  }
}

</script>

<style>
    #listTableT{
        z-index: 80;
    }
    .tblName{
        color: white;
    }
    .pgn{
        color: red;
        background: yellow;
    }

</style>
